export default "__VITE_ASSET__RB6cvaoR__"